import { render, staticRenderFns } from "./FlagItems.vue?vue&type=template&id=4f1179d8&"
import script from "./FlagItems.vue?vue&type=script&lang=js&"
export * from "./FlagItems.vue?vue&type=script&lang=js&"
import style1 from "./FlagItems.vue?vue&type=style&index=1&id=4f1179d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports